import { render, staticRenderFns } from "./CreatedTicket.vue?vue&type=template&id=c4fa1c58&scoped=true"
import script from "./CreatedTicket.vue?vue&type=script&lang=js"
export * from "./CreatedTicket.vue?vue&type=script&lang=js"
import style0 from "./CreatedTicket.vue?vue&type=style&index=0&id=c4fa1c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fa1c58",
  null
  
)

export default component.exports